import http from "./httpService";
import useAppConfig from "../../store/appConfig";

const apiUrl = useAppConfig.getState().apiUrl;
const folderIdGetter = (folderId) => {
    switch (folderId) {
        case 0: return 0;
        case -1: return -1;
        default: if (folderId) return folderId; else return -1;
    }
}

// Folders
export async function getAllFolders() {
    const {data} = await http.post(`${apiUrl}/Drive/GetFolders`, {
        parentId: null,
        viewMode: 0,
        orderBy: 0,
        sortMethod: 0,
        filterClause: "",
        isSystem: true,
        isShared: true,
        isHidden: false,
        isDeleted: false
    });
    const payload = [];
    if (data && data.isSuccess && data.value?.length) {
        data.value.forEach(i => {
            payload.push({
                id: i.dfL_ID,
                parentId: i.dfL_ParentID,
                name: i.dfL_Name,
                type: 'folder',
                size: i.dfL_Size,
                createdAt: i.dfL_CreateDate,
                isShared: i.dfL_IsShared,
            })
        })
    }
    return payload;
}
export async function getFolders(folderId) {
    const {data} = await http.post(`${apiUrl}/Drive/GetFolders`, {
        parentId: folderIdGetter(folderId),
        viewMode: 0,
        orderBy: 0,
        sortMethod: 0,
        filterClause: "",
        isSystem: true,
        isHidden: true,
        isShared: true,
        isDeleted: true
    });
    const payload = [];
    if (data && data.isSuccess && data.value?.length) {
        data.value.forEach(i => {
            payload.push({
                id: i.dfL_ID,
                parentId: i.dfL_ParentID,
                name: i.dfL_Name,
                type: 'folder',
                size: i.dfL_Size,
                createdAt: i.dfL_CreateDate,
                isShared: i.dfL_IsShared,
            })
        })
    }
    return payload;
}
export async function createFolder(parentId, name) {
    const {data} = await http.post(`${apiUrl}/Drive/CreateFolder`, {ParentId: parentId, FolderName: name});
    return data;
}
export async function deleteFolder(folderId) {
    const {data} = await http.post(`${apiUrl}/Drive/DeleteFolder?folderId=${folderId}`);
    return data;
}
export async function renameFolder(folderId, name){
    const {data} = await http.post(`${apiUrl}/Drive/RenameFolder`, {folderId, foldername: name});
    return data;
}
export async function moveFolders(folderIds, parentId) {
    const {data} = await http.post(`${apiUrl}/Drive/MoveFolders`, {FolderIds: folderIds, ParentId: parentId});
    return data;
}



// Files
export async function getFiles(folderId) {
    const {data} = await http.post(`${apiUrl}/Drive/GetFiles`, {
        folderId: folderIdGetter(folderId),
        viewMode: 0,
        orderBy: 0,
        sortMethod: 0,
        filterClause: "",
        isSystem: false,
        isHidden: false,
        isShared: false,
        isDeleted: false
    });
    const payload = [];
    if (data && data.isSuccess && data.value?.length) {

        const getFileType = (type) => {
            switch (type) {
                // Images
                case 'jpg':
                case 'jpeg':
                case 'gif':
                // case 'svg':
                case 'png': return 'img';

                default: return 'file';
            }
        }

        for (const i of data.value) {
            const type = i.dF_FileName.split('.').pop();
            payload.push({
                id: i.dF_ID,
                folderId: i.dF_FolderID,
                parentId: i.dfL_ParentID,
                title: i.dF_FileName,
                name: i.dF_FileTitle,
                size: i.dF_Size,
                type,
                thumbnail: getFileThumbnail(i.fileHashId, {width: 128, height: 128}),
                src: getFileType(type) === 'img' ? getImageFile(i.fileHashId) : null,
                createdAt: i.dF_RegDate,
                isShared: i.dF_IsShared,
                sharedId: i.dF_SharedId,
                shareType: i.dF_ShareType,
                sharePassword: i.dF_SharePassword,
                shareExpire: i.dF_ShareExpireDate,
                shareAddress: i.dF_ShareAddress,
                price: i.dF_FilePrice,
                downloadCount: i.dF_FileDownloadCount,
                description: i.dF_Description,
                relativePath: i.dF_RelativePath,
                tags: i.tags,
                fileHashId: i.fileHashId,
            })
        }
    }
    return payload;
}
export async function moveFiles(fileIds, folderId){
    const {data} = await http.post(`${apiUrl}/Drive/MoveFiles`, {FileIds: fileIds, Folderid: folderId});
    return data;
}
export async function copyFiles(fileIds, folderId){
    const {data} = await http.post(`${apiUrl}/Drive/CopyFiles`, {FileIds: fileIds, Folderid: folderId});
    return data;
}
export async function deleteFiles(fileIds){
    const {data} = await http.post(`${apiUrl}/Drive/DeleteFiles`, {fileIds});
    return data;
}
export async function downloadFiles(sourceType, data = {}, options = {}) {
    const {fileIds, folderId, isZip, linkAddress} = data;
    const { onProgress = () => null, signal } = options;
    switch (sourceType) {
        case 'Drive': {
            if (!fileIds?.length) return Promise.reject('فایلی برای دانلود مشخص نشده');
            return http.post(`${apiUrl}/Drive/DownloadFiles`, {
                sourceType,
                folderId: folderIdGetter(folderId),
                fileIds,
                isZip,
            }, {
                responseType: 'blob',
                onDownloadProgress: (e) => {
                    if (e.progress !== undefined) {
                        const progress = Math.floor(e.progress * 100);
                        onProgress(progress);
                    }
                },
                signal
            });
        }
        case 'Share': {
            if (!linkAddress) return Promise.reject('لینک فایل درخواست شده وارد نشده است');
            return http.post(`${apiUrl}/Drive/DownloadFiles`, {
                sourceType,
                linkAddress,
                fileIds,
                isZip,
            }, {
                responseType: 'blob',
                onDownloadProgress: (e) => {
                    // console.log(e)
                    if (e.progress !== undefined) {
                        const progress = Math.floor(e.progress * 100);
                        onProgress(progress);
                    }
                },
                signal
            });
        }
        default: return Promise.reject('ورودی نامعتبر');
    }
}
export async function uploadFiles(files, folderId) {
    let form = new FormData();
    form.append("folderId", folderIdGetter(folderId));
    form.append("isSystem", false);
    form.append("isHidden", false);
    form.append("isShared", true);
    files.forEach((item) => {
        form.append("files", item);
    });
    return await http.post(`${apiUrl}/drive/UploadFiles`, form);
}
export async function uploadFile(file, onProgress, folderId) {
    const formData = new FormData();
    formData.append("folderId", folderIdGetter(folderId));
    formData.append("isSystem", false);
    formData.append("isHidden", false);
    formData.append("isShared", true);
    formData.append("files", file);
    const response = await http.post(`${apiUrl}/drive/UploadFiles`, formData,
        {
            headers: { "Content-Type": "multipart/form-data", },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                onProgress(percentCompleted);
            },
            signal: file.controller.signal
        });
    return response;
}
export async function addTag(fileId, name) {
    return http.post(`${apiUrl}/Tag/AddTag`, {fileId, name});
}
export async function removeTag(fileId, name) {
    return http.post(`${apiUrl}/Tag/RemoveTag`, {fileId, name});
}

// Both
export async function searchInDrive(query) {
    const result = await http.post(`${apiUrl}/Drive/SearchInDrive`, {searchText: query});
    const data = result?.data;
    const payload = {
        folders: [],
        files: [],
    };
    const {foldersList, filesList} = data?.value;
    if (data && data.isSuccess && foldersList?.length) {
        foldersList.forEach(i => {
            payload.folders.push({
                id: i.dfL_ID,
                parentId: i.dfL_ParentID,
                name: i.dfL_Name,
                type: 'folder',
                size: i.dfL_Size,
                createdAt: i.dfL_CreateDate,
                isShared: i.dfL_IsShared,
            })
        })
    }
    if (data && data.isSuccess && filesList?.length) {
        filesList.forEach(i => {
            const type = i.dF_FileName.split('.').pop();
            payload.files.push({
                id: i.dF_ID,
                folderId: i.dF_FolderID,
                parentId: i.dfL_ParentID,
                title: i.dF_FileName,
                name: i.dF_FileTitle,
                size: i.dF_Size,
                type,
                src: getFileThumbnail(i.fileHashId),
                createdAt: i.dF_RegDate,
                isShared: i.dF_IsShared,
                sharedId: i.dF_SharedId,
                shareType: i.dF_ShareType,
                sharePassword: i.dF_SharePassword,
                shareExpire: i.dF_ShareExpireDate,
                shareAddress: i.dF_ShareAddress,
                price: i.dF_FilePrice,
                downloadCount: i.dF_FileDownloadCount,
                description: i.dF_Description,
                relativePath: i.dF_RelativePath,
                tags: i.tags,
            })
        })
    }
    return payload;
}

// User
export async function getUserInformation() {
    return http.get(`${apiUrl}/User/GetUserInformation`);
}
export async function changePersonalInformation(payload) {
    return await http.post(`${apiUrl}/user/ChangePersonalInforrmation`, payload);
}
export async function changePassword(payload) {
    return await http.post(`${apiUrl}/user/ChangePassword`, payload);
}
export async function refreshTheToken(accessToken, refreshToken) {
    return http.post(`${apiUrl}/user/RefreshToken`, {access_Token: accessToken, refresh_Token: refreshToken})
}
export async function changeMasterAccount(email, refreshToken) {
    return http.post(`${apiUrl}/User/ChangeMasterAccount`, {EmailAddress: email, RefreshToken: refreshToken});
}


// Shares
export async function shareFolder(payload) {
    return await http.post(`${apiUrl}/Drive/ShareFolder`, payload);
}
export async function getShareFolder(linkAddress, password) {
    return await http.post(`${apiUrl}/Drive/GetShareFolder`, {linkAddress, password});
}
export async function getShareFiles(linkAddress, password) {
    return await http.post(`${apiUrl}/Drive/GetShareFiles`, {linkAddress, password});
}
export async function getShareFilesInfo(linkAddress) {
    return await http.get(`${apiUrl}/drive/GetShareFilesInfo?linkAddress=${linkAddress}`);
}
export async function getMyShares(page, size, options = {}) {
    const {filterClause, sortMethod, orderBy} = options;
    let sort;
    let order;
    switch (sortMethod) {
        case "ascending": sort = 1; break;
        case "descending": sort = 2; break;
        default: sort = 2; break;
    }
    switch(orderBy) {
        case "date": order = 1; break;
        case "title": order = 2; break;
        case "phoneNumber": order = 3; break;
        case "firstName": order = 4; break;
        case "lastName": order = 5; break;
        default: order = 1; break;
    }
    return http.post(`${apiUrl}/Drive/MySharesGetAll`, {pageSize: size, pageNumber: page, sortMethod: sort, orderBy: order, filterClause })
}
export async function getSharesForMe(page, size, options = {}) {
    const {filterClause, sortMethod, orderBy} = options;
    let sort;
    let order;
    switch (sortMethod) {
        case "ascending": sort = 1; break;
        case "descending": sort = 2; break;
        default: sort = 2; break;
    }
    switch(orderBy) {
        case "date": order = 1; break;
        case "title": order = 2; break;
        case "phoneNumber": order = 3; break;
        case "firstName": order = 4; break;
        case "lastName": order = 5; break;
        default: order = 1; break;
    }
    return http.post(`${apiUrl}/Drive/SharesForMeGetAll`, {pageSize: size, pageNumber: page, sortMethod: sort, orderBy: order, filterClause })
}
export async function shareFiles(payload) {
    return await http.post(`${apiUrl}/Drive/ShareFiles`, payload);
}
export async function requestShareFile(sender, title, description) {
    return await http.post(`${apiUrl}/Drive/RequestShareFile`, {RequestForEmailMobile: sender, title, description});
}
export async function getRequestShareFileInfo(linkAddress) {
    return await http.get(`${apiUrl}/Drive/GetRequestShareFileInfo?linkAddress=${linkAddress}`);
}
export async function completeRequestShareFile(linkAddress, fileIds)  {
    return http.post(`${apiUrl}/Drive/CompleteRequestShareFile`, {linkAddress, fileIds});
}

// AddressBook
export async function getAllAddressBookGroups() {
    return await http.get(`${apiUrl}/AddressBook/AddressBookGroupsGetAll`);
}
export async function addAddressBookGroup(name) {
    return await http.post(`${apiUrl}/AddressBook/AddAddressBookGroups`, {name});
}
export async function removeAddressBookGroup(id) {
    return await http.get(`${apiUrl}/AddressBook/RemoveAddressBookGroups?id=${id}`);
}
export async function editAddressBookGroup(id, name) {
    return await http.post(`${apiUrl}/AddressBook/EditAddressBookGroups`, {id, name});
}

export async function getAllAddressBooks() {
    return await http.get(`${apiUrl}/AddressBook/AddressBookContactsGetAll`);
}
export async function removeAddressBook(id) {
    return await http.get(`${apiUrl}/AddressBook/RemoveAddressBookContacts?id=${id}`);
}
export async function addAddressBook(payload) {
    return await http.post(`${apiUrl}/AddressBook/AddAddressBookContacts`, payload);
}
export async function editAddressBook(payload) {
    return await http.post(`${apiUrl}/AddressBook/EditAddressBookContacts`, payload);
}

// Plans and Payment
export async function getAllActivePacks() {
    return http.get(`${apiUrl}/Packs/GetAllActivePacks`);
}
export async function pay(payType, data) {
    switch (payType) {
        case "package":
            const { packageId } = data;
            if (!packageId) return Promise.reject('شناسه پکیج مورد نظر صحیح نمی باشد')
            return http.post(`${apiUrl}/Payment/Pay`, {PayType: 1, Data: packageId, Amount: 0});
        case "balance":
            const { amount } = data;
            if (!amount) return Promise.reject('مقدار شارژ وارد شده صحیح نمی باشد')
            return http.post(`${apiUrl}/Payment/Pay`, {PayType: 2, Amount: amount});
        default: return;
    }
};
export async function verifyPayment(authority, status) {
    return http.get(`${apiUrl}/Payment/VerifyPay?Authority=${authority}&Status=${status}`);
}
export async function getUsedDriveSpace() {
    return http.get(`${apiUrl}/User/GetUsedDriveSpace`);
}
export async function getTransactions(page, perPage) {
    return http.post(`${apiUrl}/Payment/TransactionGetAll`, {pageNumber: page, pageSize: perPage});
}
// export async function getUserBalance() {
//     return http.get(`${apiUrl}/Payment/GetUserAccountBalance`);
// }

// Others
export async function getAppVersion() {
    return http.get(`${apiUrl}/General/GetAppVersion`);
}
export function getFileThumbnail(fileHashId, options = {}) {
    const { width, height } = options
    return `${apiUrl}/fileHandler/GetFileThumbnail?fileHash=${fileHashId}${width ? `&width=${width}` : ''}${height ? `&height=${height}` : ''}`;
}
export function getImageFile(fileHash) {
    return `${apiUrl}/fileHandler/GetImageFile?fileHash=${fileHash}`;
}
export function downloadBlob(blob, name) {
    // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
    const blobUrl = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");

    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = name;
    // Append link to the body
    document.body.appendChild(link);

    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
        new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        })
    );

    // Remove link from body
    document.body.removeChild(link);
}
